// ============================================================================
// Accordion — FAQ section
// ----------------------------------------------------------------------------
// Single-open accordion: clicking a head closes all others and opens that one
// by setting body height to its wrapper's offsetHeight (so CSS can transition).
// First item auto-opens on page load.
//
// There are TWO repeaters on the service page (one per ACF list). We treat
// them as a single accordion so only one item is open across both — matches
// the original behavior which queried `.accordition__item` globally.
// ============================================================================

document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".accordition__item");
  if (!items.length) return;

  function closeAll() {
    items.forEach(function (item) {
      item.classList.remove("open");
      const body = item.querySelector(".accordition__body");
      if (body) body.style.height = "0px";
    });
  }

  function open(item) {
    closeAll();
    const body = item.querySelector(".accordition__body");
    const bodyWrap = item.querySelector(".accordition__body-wrapper");
    if (!body || !bodyWrap) return;

    item.classList.add("open");
    body.style.height = bodyWrap.offsetHeight + "px";
  }

  items.forEach(function (item) {
    const head = item.querySelector(".accordition__head");
    if (!head) return;
    head.addEventListener("click", function () {
      // If the clicked item is already open, close it (toggle behaviour).
      // Comment out this block if you prefer "always one open".
      if (item.classList.contains("open")) {
        closeAll();
        return;
      }
      open(item);
    });
  });

  // Auto-open the first item on load — matches original.
  open(items[0]);

  // Recompute open item's height on resize, in case wrapping changes content
  // height (long text wrapping to extra lines, responsive layout shifts).
  window.addEventListener("resize", function () {
    const openItem = document.querySelector(".accordition__item.open");
    if (!openItem) return;
    const body = openItem.querySelector(".accordition__body");
    const bodyWrap = openItem.querySelector(".accordition__body-wrapper");
    if (body && bodyWrap) {
      body.style.height = bodyWrap.offsetHeight + "px";
    }
  });
});
